import Api from "./axiosVersion1";

export const getNotifications = async () => {
  return await Api.get("/notifications");
};

export const markNotificationAsRead = async (notificationId) => {
  return await Api.patch(`/notifications/${notificationId}/read`);
};
